(function() {
  'use strict';

  angular
    .module('boxPreview')
    .directive('mfBoxpreviewNarration', narration);

  narration.$inject = [];

  function narration() {
    return {
      link: function(scope) {
        var outer = $('#slideOuter');
        if (scope.narrationTemplate) {
          outer.addClass('crocodocNarration');
        }

        scope.$on('$destroy', function() {
          outer.removeClass('crocodocNarration');
        });
      }
    };
  }
})();
